module.exports = __webpack_public_path__ + "static/media/dakota.4186b8c4.png";